<template>
<div
    :class="{
        'VehicleStateVehicle': 1,
        'VehicleStateVehicle--mobileExpanded': mobileExpanded,
        'VehicleStateVehicle--variantCompatibilityChecker': variant == 'compatibility-checker',
        'VehicleStateVehicle--variantHeaderOverlap': variant == 'header-overlap',
        'VehicleStateVehicle--variantProductOverlay': variant == 'product-overlay',
        'VehicleStateVehicle--service': variant === 'service'
    }">
    <button
        @click="mobileExpanded = !mobileExpanded"
        class="VehicleStateVehicle__MobileHeader">
        <div class="VehicleStateVehicle__Image">
            IMAGE<br>
            IMAGE<br>
            IMAGE<br>
            IMAGE<br>
            IMAGE
        </div>
        <div ref="icon" class="VehicleStateVehicle__Compatiblity is-loading">
            <div v-if="this.compatibilty === 'Compatible'" class="VehicleStateVehicle__Icon--Compatible">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon__tick" viewBox="0 0 36 36"><path d="M14.82 25.32a1 1 0 0 1-.68-.28l-6.36-6.37a1 1 0 0 1 1.35-1.34l6.36 6.36a.94.94 0 0 1 0 1.35 1 1 0 0 1-.67.28z"/><path d="M14.82 25.32a1 1 0 0 1-.68-.28 1 1 0 0 1 0-1.35L26.87 11a1 1 0 1 1 1.35 1.35L15.49 25a1 1 0 0 1-.67.32z"/></svg>
            </div>
            <div v-else-if="this.compatibilty === 'Incompatible'" class="VehicleStateVehicle__Icon--Incompatible">
                <svg  xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="15" height="15" viewBox="0 0 15 15"><g><g><path d="M13.233 0L15 1.767 9.268 7.5 15 13.233 13.233 15 7.5 9.268 1.767 15 0 13.233 5.732 7.5 0 1.767 1.767 0 7.5 5.732z"/></g></g></svg>
            </div>
            <div v-else class="VehicleStateVehicle__Icon--Compatible">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon__tick" viewBox="0 0 36 36"><path d="M14.82 25.32a1 1 0 0 1-.68-.28l-6.36-6.37a1 1 0 0 1 1.35-1.34l6.36 6.36a.94.94 0 0 1 0 1.35 1 1 0 0 1-.67.28z"/><path d="M14.82 25.32a1 1 0 0 1-.68-.28 1 1 0 0 1 0-1.35L26.87 11a1 1 0 1 1 1.35 1.35L15.49 25a1 1 0 0 1-.67.32z"/></svg>
            </div>
        </div>
        <div class="VehicleStateVehicle__MakeModel">
            {{ vehicle.make }} {{ vehicle.model }}
        </div>
        <div class="VehicleStateVehicle__Year">
            {{ vehicle.year }}
        </div>
        <app-icon
            :icon="iconChevronUp"
            class="VehicleStateVehicle__MobileHeaderCaret"/>
    </button>
    <div class="VehicleStateVehicle__Content">
        <div class="VehicleStateVehicle__Details">
            <div class="VehicleStateVehicle__Image">
                IMAGE<br>
                IMAGE<br>
                IMAGE<br>
                IMAGE<br>
                IMAGE
            </div>
            <div class="VehicleStateVehicle__MakeModel">
                {{ vehicle.make }} {{ vehicle.model }}
            </div>
            <div class="VehicleStateVehicle__Year">
                {{ vehicle.year }}
            </div>
            <div v-if="!variant === 'service'" class="VehicleStateVehicle__Seporator">
                -
            </div>
            <div v-if="!variant === 'service'" class="VehicleStateVehicle__Info">
                You will only see products compatible with your vehicle.
            </div>
            <!--
            <refine-mmy-vehicle-lookup
                @change="onVehicleRefine"
                :disabled="!canRefine"
                class="VehicleStateVehicle__Refine"/>
            -->
        </div>
        <div class="VehicleStateVehicle__Actions">
            <!--
            <button
                :disabled="true"
                class="VehicleStateVehicle__Action">
                {{ $t('collection_vehicle_bar_vehicle.edit_action') }}
            </button>
            -->
            <button
                @click="onClear"
                class="VehicleStateVehicle__Action">
                {{ $t('collection_vehicle_bar_vehicle.clear_action') }}
            </button>
        </div>
    </div>
</div>
</template>

<script>
import { components as partindexComponents } from '@scripts/services/partindex'

import { garageService } from '@scripts/services/garageService'
import { compatibilityService } from '@scripts/services/compatibilityService'

import iconChevronUp from '@icons/icon_chevron_up.svg'

export default {
    components: {
        ...partindexComponents
    },
    props: {
        variant: String,
        productId: Number
    },
    data () {
        return {
            iconChevronUp,
            mobileExpanded: false,
            compatibilty: 'Unknown'
        }
    },
    computed: {
        vehicle () {
            return garageService.activeVehicle || null
        }
    },
    methods: {
        isVinVehicleDetails (details) {
            return !!details.vin
        },
        onClear () {
            garageService.setActive(null)
        },
        setCompatibility (result) {
            const { definitelyCompatible, definitelyIncompatible, possiblyCompatible, possiblyIncompatible } = result
            this.compatibilty = 'Unknown'

            if (definitelyCompatible) {
                this.compatibilty = 'Compatible'
            } else if (definitelyIncompatible) {
                this.compatibilty = 'Incompatible'
            } else if (possiblyCompatible || possiblyIncompatible) {
                this.compatibilty = 'Possibly'
            }

            if (this.$refs.icon) this.$refs.icon.classList.remove('is-loading')
        }
    },
    mounted () {
        if (this.productId) {
            compatibilityService.subscribeCompatibility(this.productId, (result) => this.setCompatibility(result))
        }
    }
}
</script>

<style lang="scss">
$fontRegular: 'Ford Antenna', Helvetica, Arial, sans-serif;
$fontCondensed: 'Ford Antenna Condensed', 'Ford Antenna Cond', Helvetica, Arial, sans-serif;

$mobileBreakpoint: 768px;
$smallDesktopBreakpoint: 1024px;

.VehicleStateVehicle {
    min-height: 150px;

    display: flex;
    align-items: flex-end;
    justify-content: stretch;

    &__Content {
        width: 100%;
        height: 75px;
        box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);

        display: flex;
    }

    &__Details {
        flex-grow: 1;
        background-color: #f2f2f2;

        display: flex;
        align-items: center;
    }

    &__Image {
        margin-right: 20px;
        align-self: flex-end;

        background: rgba(255,0,0,0.5);
        margin-top: -30px;

        // TODO: vehicle images
        opacity: 0;
        width: 20px;
    }
    &__MakeModel {
        margin-right: 20px;

        color: #4d4d4d;
        font-size: 16px;
        font-weight: 700;
        line-height: 26px;
    }
    &__Year {
        margin-right: 20px;

        color: #000;
        font-size: 16px;
        line-height: 26px;
    }

    &__Info {
        font-size: 16px;
        line-height: 26px;
        color: #656565;
    }

    &__Seporator {
        margin-right: 15px;
        color: #656565;
    }

    &__Refine {
        flex-grow: 1;
    }

    &__Actions {
        flex-grow: 0;
        min-height: 70px;

        display: flex;
    }

    &__Action {
        appearance: none;
        border: none;
        outline: none;

        padding: 20px 60px;
        background-color: #102b4e;

        color: white;
        font-size: 16px;
        letter-spacing: 1px;
        line-height: 26px;
        text-decoration: underline;

        position: relative;

        + .VehicleStateVehicle__Action {
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                height: 16px;
                border-left: 1px solid white;
                opacity: 0.5;
            }
        }
    }

    &__MobileHeader {
        appearance: none;
        border: none;
        background: none;
        outline: none;

        min-height: 60px;
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        background: #f2f2f2;

        display: none;
    }
    &__MobileHeaderCaret {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%) rotate(180deg);
    }
    &__Compatiblity {
        margin-right: 10px;

        &.is-loading {
            opacity: 0;
        }
    }
    &__Icon--Compatible {
        color: #008200;
    }
    &__Icon--Incompatible {
        color: #a42828;
    }
    @media screen and (max-width: $mobileBreakpoint) {
        min-height: 0;
        flex-direction: column;
        background: #f2f2f2;

        &__Info {
            display: none;
        }

        &__Seporator {
            display: none;
        }

        &__MobileHeader {
            display: flex;
        }
        &__Content {
            height: auto;
            flex-direction: column;
            align-items: stretch;
        }
        &__Actions {
            min-height: 60px;
        }
        &__Action {
            width: 100%;
            padding: 15px 60px;
        }

        &__Content {
            display: none;

            .VehicleStateVehicle__Image,
            .VehicleStateVehicle__MakeModel,
            .VehicleStateVehicle__Year {
                display: none;
            }
        }
        &--mobileExpanded {
            .VehicleStateVehicle__MobileHeaderCaret {
                transform: translateY(-50%);
            }
            .VehicleStateVehicle__Content {
                display: flex;
            }
        }
    }

    // Variant: header-overlap
    // Should be positioned under a large header banner.
    // Overlaps the bottom edge of the header.
    &--variantHeaderOverlap {
        // Vetical alignment
        margin-top: -76px;
        position: relative;
        z-index: 10;
        @media screen and (max-width: $mobileBreakpoint) {
            // On mobile, attach below the header
            margin-top: 0;
        }
    }

    // Variant: product-overlay
    // Similar to the mobile layout
    // Displays like a dropdown
    &--variantProductOverlay {
        // Vetical alignment
        position: relative;
        z-index: 10;
        @media screen and (max-width: $mobileBreakpoint) {
            margin-top: 0;
        }

        .VehicleStateVehicle__Details {
            display: none;
        }

        // Replicate mobile styling
        min-height: 0;
        flex-direction: column;
        background: #f2f2f2;

        .VehicleStateVehicle__Content {
            position: absolute;
            left: 0;
            right: 0;
            top: 100%;
            z-index: 5;
        }

        @media screen and (min-width: $mobileBreakpoint) {
            .VehicleStateVehicle__MobileHeader {
                display: flex;
            }
            .VehicleStateVehicle__Content {
                height: auto;
                flex-direction: column;
                align-items: stretch;
            }
            .VehicleStateVehicle__Actions {
                min-height: 60px;
            }
            .VehicleStateVehicle__Action {
                width: 100%;
                padding: 15px 60px;
            }

            .VehicleStateVehicle__Content {
                display: none;

                .VehicleStateVehicle__Image,
                .VehicleStateVehicle__MakeModel,
                .VehicleStateVehicle__Year {
                    display: none;
                }
            }
            &.VehicleStateVehicle--mobileExpanded {
                .VehicleStateVehicle__MobileHeaderCaret {
                    transform: translateY(-50%);
                }
                .VehicleStateVehicle__Content {
                    display: flex;
                }
            }
        }
    }

    // Variant: compatibility-checker
    // Used on the compatibility section of the product page
    &--variantCompatibilityChecker {
        min-height: 0;

        @media screen and (max-width: $mobileBreakpoint) {
            // Always show clear button
            .VehicleStateVehicle__Content {
                display: unset;
            }
        }
    }

    // Variant: service
    // Used on the service plans page
    &--service {
        .VehicleStateVehicle__Details {
            background-color: #FFF;
        }

        @media screen and (max-width: $mobileBreakpoint) {
            .VehicleStateVehicle__MobileHeader {
                background-color: #FFF;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// VehicleStateVehicle.vue?1ba2cd28